import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopNavigation from '../../components/feature/TopNavigation';
import BottomNavigation from '../../components/feature/BottomNavigation';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';

export default function ProjectDetails() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'overview' | 'schedule' | 'team'>('overview');

  const project = {
    id: 1,
    title: 'معرض الرياض الدولي للتقنية',
    company: 'شركة المعارض السعودية',
    startDate: '2024-01-15',
    endDate: '2024-01-18',
    progress: 60,
    role: 'مضيف استقبال',
    dailyRate: '150',
    totalEarnings: '600',
    image: 'https://public.readdy.ai/ai/img_res/47c11e7b5b1f1e83ccd605735ad0e771.jpg',
    status: 'جاري العمل',
    location: 'مركز الرياض الدولي للمؤتمرات',
    description: 'معرض دولي للتقنية يضم أحدث الابتكارات في مجال التكنولوجيا والذكاء الاصطناعي. يشارك فيه أكثر من 200 شركة من جميع أنحاء العالم.',
    supervisor: {
      name: 'سارة أحمد',
      phone: '+966 50 123 4567',
      email: 'sara.ahmed@exhibitions.sa',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Saudi%20woman%20portrait%2C%20business%20attire%2C%20confident%20smile%2C%20clean%20background%2C%20professional%20headshot%2C%20modern%20lighting&width=100&height=100&seq=supervisor1&orientation=squarish'
    },
    schedule: [
      {
        date: '2024-01-15',
        day: 'الاثنين',
        shift: '08:00 - 16:00',
        tasks: ['إعداد منطقة الاستقبال', 'استقبال الزوار المبكرين', 'توزيع الخرائط والبرامج'],
        status: 'مكتمل'
      },
      {
        date: '2024-01-16',
        day: 'الثلاثاء',
        shift: '08:00 - 16:00',
        tasks: ['استقبال الوفود الرسمية', 'تنسيق الجولات المرشدة', 'مساعدة في الفعاليات الخاصة'],
        status: 'مكتمل'
      },
      {
        date: '2024-01-17',
        day: 'الأربعاء',
        shift: '08:00 - 16:00',
        tasks: ['استقبال الزوار', 'تقديم المساعدة التقنية', 'تنظيم طوابير الانتظار'],
        status: 'اليوم'
      },
      {
        date: '2024-01-18',
        day: 'الخميس',
        shift: '08:00 - 16:00',
        tasks: ['استقبال الزوار', 'مساعدة في إغلاق المعرض', 'تنظيف وترتيب المنطقة'],
        status: 'قادم'
      }
    ],
    team: [
      {
        name: 'أحمد محمد',
        role: 'مضيف استقبال',
        avatar: 'https://readdy.ai/api/search-image?query=Professional%20young%20Saudi%20man%20portrait%2C%20business%20attire%2C%20confident%20smile%2C%20clean%20background%2C%20professional%20headshot%2C%20modern%20lighting&width=80&height=80&seq=team1&orientation=squarish',
        rating: 4.8,
        isMe: true
      },
      {
        name: 'فاطمة علي',
        role: 'مضيفة استقبال',
        avatar: 'https://readdy.ai/api/search-image?query=Professional%20young%20Saudi%20woman%20portrait%2C%20business%20attire%2C%20confident%20smile%2C%20clean%20background%2C%20professional%20headshot%2C%20modern%20lighting&width=80&height=80&seq=team2&orientation=squarish',
        rating: 4.9
      },
      {
        name: 'محمد سالم',
        role: 'منسق فعاليات',
        avatar: 'https://readdy.ai/api/search-image?query=Professional%20middle-aged%20Saudi%20man%20portrait%2C%20business%20attire%2C%20confident%20smile%2C%20clean%20background%2C%20professional%20headshot%2C%20modern%20lighting&width=80&height=80&seq=team3&orientation=squarish',
        rating: 4.7
      },
      {
        name: 'نورا خالد',
        role: 'مساعدة تقنية',
        avatar: 'https://readdy.ai/api/search-image?query=Professional%20young%20Saudi%20woman%20portrait%2C%20business%20attire%2C%20confident%20smile%2C%20clean%20background%2C%20professional%20headshot%2C%20modern%20lighting&width=80&height=80&seq=team4&orientation=squarish',
        rating: 4.6
      }
    ]
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'مكتمل': return 'text-[#4CAF50] bg-[#4CAF50]/10';
      case 'اليوم': return 'text-[#1565C0] bg-[#1565C0]/10';
      case 'قادم': return 'text-[#607D8B] bg-[#607D8B]/10';
      default: return 'text-[#757575] bg-[#F5F5F5]';
    }
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ar-SA', { 
      month: 'long', 
      day: 'numeric' 
    });
  };

  return (
    <div className="min-h-screen bg-[#FDFDFD]">
      <TopNavigation 
        title="تفاصيل المشروع"
        leftAction={
          <button 
            onClick={() => navigate('/projects')}
            className="w-8 h-8 flex items-center justify-center"
          >
            <i className="ri-arrow-right-line text-lg"></i>
          </button>
        }
        rightAction={
          <button className="w-8 h-8 flex items-center justify-center">
            <i className="ri-more-line text-lg"></i>
          </button>
        }
      />

      <div className="pt-14 pb-20 px-4">
        {/* Project Header */}
        <div className="relative h-48 rounded-lg overflow-hidden mb-6 mt-4">
          <img 
            src={project.image} 
            alt={project.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/30"></div>
          <div className="absolute bottom-4 left-4 right-4">
            <h1 className="text-white text-xl font-bold mb-2">{project.title}</h1>
            <p className="text-white/90 text-sm">{project.company}</p>
          </div>
          <div className="absolute top-4 right-4">
            <span className="px-3 py-1 bg-white/90 rounded-full text-xs font-medium text-[#333333]">
              {project.status}
            </span>
          </div>
        </div>

        {/* Progress Card */}
        <Card className="mb-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-[#333333]">تقدم المشروع</h3>
            <span className="text-2xl font-bold text-[#1565C0]">{project.progress}%</span>
          </div>
          <div className="w-full bg-[#F5F5F5] rounded-full h-3 mb-4">
            <div 
              className="bg-[#1565C0] h-3 rounded-full transition-all duration-300"
              style={{ width: `${project.progress}%` }}
            ></div>
          </div>
          <div className="grid grid-cols-3 gap-4 text-center">
            <div>
              <p className="text-lg font-bold text-[#4CAF50]">{project.dailyRate} ريال</p>
              <p className="text-[#757575] text-xs">يومياً</p>
            </div>
            <div>
              <p className="text-lg font-bold text-[#1565C0]">{project.totalEarnings} ريال</p>
              <p className="text-[#757575] text-xs">إجمالي الأرباح</p>
            </div>
            <div>
              <p className="text-lg font-bold text-[#607D8B]">4 أيام</p>
              <p className="text-[#757575] text-xs">مدة المشروع</p>
            </div>
          </div>
        </Card>

        {/* Tabs */}
        <div className="mb-6">
          <div className="flex bg-[#F5F5F5] rounded-lg p-1">
            {[
              { key: 'overview', label: 'نظرة عامة' },
              { key: 'schedule', label: 'الجدول' },
              { key: 'team', label: 'الفريق' }
            ].map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key as any)}
                className={`flex-1 py-2 px-3 rounded-md text-sm font-medium transition-colors ${
                  activeTab === tab.key
                    ? 'bg-white text-[#1565C0] shadow-sm'
                    : 'text-[#607D8B]'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content */}
        {activeTab === 'overview' && (
          <div className="space-y-6">
            {/* Project Info */}
            <Card>
              <h3 className="text-lg font-semibold text-[#333333] mb-4">معلومات المشروع</h3>
              <div className="space-y-3">
                <div className="flex items-center">
                  <i className="ri-user-line text-[#607D8B] ml-3"></i>
                  <div>
                    <p className="text-[#757575] text-sm">دورك</p>
                    <p className="font-medium text-[#333333]">{project.role}</p>
                  </div>
                </div>
                <div className="flex items-center">
                  <i className="ri-map-pin-line text-[#607D8B] ml-3"></i>
                  <div>
                    <p className="text-[#757575] text-sm">الموقع</p>
                    <p className="font-medium text-[#333333]">{project.location}</p>
                  </div>
                </div>
                <div className="flex items-center">
                  <i className="ri-calendar-line text-[#607D8B] ml-3"></i>
                  <div>
                    <p className="text-[#757575] text-sm">المدة</p>
                    <p className="font-medium text-[#333333]">
                      {formatDate(project.startDate)} - {formatDate(project.endDate)}
                    </p>
                  </div>
                </div>
              </div>
            </Card>

            {/* Description */}
            <Card>
              <h3 className="text-lg font-semibold text-[#333333] mb-4">وصف المشروع</h3>
              <p className="text-[#757575] leading-relaxed">{project.description}</p>
            </Card>

            {/* Supervisor */}
            <Card>
              <h3 className="text-lg font-semibold text-[#333333] mb-4">المشرف</h3>
              <div className="flex items-center">
                <img 
                  src={project.supervisor.avatar} 
                  alt={project.supervisor.name}
                  className="w-12 h-12 rounded-full object-cover ml-3"
                />
                <div className="flex-1">
                  <h4 className="font-semibold text-[#333333]">{project.supervisor.name}</h4>
                  <p className="text-[#757575] text-sm">{project.supervisor.phone}</p>
                </div>
                <div className="flex gap-2">
                  <button className="w-10 h-10 bg-[#4CAF50]/10 rounded-full flex items-center justify-center">
                    <i className="ri-phone-line text-[#4CAF50]"></i>
                  </button>
                  <button className="w-10 h-10 bg-[#1565C0]/10 rounded-full flex items-center justify-center">
                    <i className="ri-message-line text-[#1565C0]"></i>
                  </button>
                </div>
              </div>
            </Card>
          </div>
        )}

        {activeTab === 'schedule' && (
          <div className="space-y-4">
            {project.schedule.map((day, index) => (
              <Card key={index} className={`${day.status === 'اليوم' ? 'border-r-4 border-[#1565C0]' : ''}`}>
                <div className="flex items-start justify-between mb-3">
                  <div>
                    <h4 className="font-semibold text-[#333333]">{day.day}</h4>
                    <p className="text-[#757575] text-sm">{formatDate(day.date)}</p>
                  </div>
                  <div className="text-right">
                    <p className="font-medium text-[#333333]">{day.shift}</p>
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(day.status)}`}>
                      {day.status}
                    </span>
                  </div>
                </div>
                <div>
                  <h5 className="font-medium text-[#333333] mb-2">المهام:</h5>
                  <ul className="space-y-1">
                    {day.tasks.map((task, taskIndex) => (
                      <li key={taskIndex} className="flex items-start">
                        <i className="ri-checkbox-circle-line text-[#4CAF50] ml-2 mt-1 flex-shrink-0 text-sm"></i>
                        <span className="text-[#757575] text-sm">{task}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </Card>
            ))}
          </div>
        )}

        {activeTab === 'team' && (
          <div className="space-y-4">
            {project.team.map((member, index) => (
              <Card key={index} className={`${member.isMe ? 'border-r-4 border-[#1565C0]' : ''}`}>
                <div className="flex items-center">
                  <img 
                    src={member.avatar} 
                    alt={member.name}
                    className="w-12 h-12 rounded-full object-cover ml-3"
                  />
                  <div className="flex-1">
                    <div className="flex items-center">
                      <h4 className="font-semibold text-[#333333]">{member.name}</h4>
                      {member.isMe && (
                        <span className="px-2 py-1 bg-[#1565C0]/10 text-[#1565C0] rounded-full text-xs font-medium mr-2">
                          أنت
                        </span>
                      )}
                    </div>
                    <p className="text-[#757575] text-sm">{member.role}</p>
                    <div className="flex items-center mt-1">
                      <i className="ri-star-fill text-[#FBC02D] text-sm ml-1"></i>
                      <span className="text-[#333333] text-sm font-medium">{member.rating}</span>
                    </div>
                  </div>
                  {!member.isMe && (
                    <button className="w-10 h-10 bg-[#1565C0]/10 rounded-full flex items-center justify-center">
                      <i className="ri-message-line text-[#1565C0]"></i>
                    </button>
                  )}
                </div>
              </Card>
            ))}
          </div>
        )}

        {/* Quick Actions */}
        <div className="grid grid-cols-2 gap-4 mt-6">
          <Button variant="outline" className="h-16">
            <div className="text-center">
              <i className="ri-time-line text-lg mb-1 block"></i>
              <span className="text-sm">تسجيل الحضور</span>
            </div>
          </Button>
          <Button variant="outline" className="h-16">
            <div className="text-center">
              <i className="ri-camera-line text-lg mb-1 block"></i>
              <span className="text-sm">تقرير يومي</span>
            </div>
          </Button>
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
}